import { render, staticRenderFns } from "./CategoryTiles.vue?vue&type=template&id=3769a9d8&scoped=true&"
import script from "./CategoryTiles.vue?vue&type=script&lang=js&"
export * from "./CategoryTiles.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTiles.vue?vue&type=style&index=0&id=3769a9d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3769a9d8",
  null
  
)

export default component.exports